import {
  FETCH_LINKS_LIST,
  FETCH_LINKS_LIST_ERROR,
  CLEAR_FETCH_LINKS_LIST,
  APPLY_LINK_DRAG,
  APPLY_LINK_DRAG_ERROR,
  CLEAR_LINK_DRAG,
  ADD_LINK_SUCCESS,
  ADD_LINK_ERROR,
  CLEAR_ADD_LINK,
  DELETE_LINK_SUCCESS,
  DELETE_LINK_ERROR,
  CLEAR_DELETE_LINK,
  PATCH_LINK_SUCCESS,
  PATCH_LINK_ERROR,
  CLEAR_PATCH_LINK,
  FETCH_SOCIAL_NETWORKS_LIST,
  FETCH_SOCIAL_NETWORKS_LIST_ERROR,
  CLEAR_FETCH_SOCIAL_NETWORKS_LIST,
  FETCH_SOCIAL_LINKS_LIST,
  FETCH_SOCIAL_LINKS_LIST_ERROR,
  CLEAR_FETCH_SOCIAL_LINKS_LIST,
  ADD_SOCIAL_LINK_SUCCESS,
  ADD_SOCIAL_LINK_ERROR,
  CLEAR_ADD_SOCIAL_LINK,
  DELETE_SOCIAL_LINK_SUCCESS,
  DELETE_SOCIAL_LINK_ERROR,
  CLEAR_DELETE_SOCIAL_LINK,
  PATCH_SOCIAL_LINK_SUCCESS,
  PATCH_SOCIAL_LINK_ERROR,
  CLEAR_PATCH_SOCIAL_LINK,
  SET_SOCIAL_LINKS_BUTTONS_MODE_SUCCESS,
  SET_SOCIAL_LINKS_BUTTONS_MODE_ERROR,
  CLEAR_SET_SOCIAL_LINKS_BUTTONS_MODE,
  REQUEST_SOCIAL_LINK_STATUS_SUCCESS,
  REQUEST_SOCIAL_LINK_STATUS_ERROR,
  CLEAR_REQUEST_SOCIAL_LINK_STATUS,
  FETCH_MOBILE_APPS_LINKS_LIST,
  FETCH_MOBILE_APPS_LINKS_LIST_ERROR,
  CLEAR_FETCH_MOBILE_APPS_LINKS_LIST,
  ADD_MOBILE_APPS_LINK_SUCCESS,
  ADD_MOBILE_APPS_LINK_ERROR,
  CLEAR_ADD_MOBILE_APPS_LINK,
  PATCH_MOBILE_APPS_LINK_SUCCESS,
  PATCH_MOBILE_APPS_LINK_ERROR,
  CLEAR_PATCH_MOBILE_APPS_LINK,
  DELETE_MOBILE_APPS_LINK_SUCCESS,
  DELETE_MOBILE_APPS_LINK_ERROR,
  CLEAR_DELETE_MOBILE_APPS_LINK,
  APPLY_MOBILE_APPS_LINK_DRAG_SUCCESS,
  APPLY_MOBILE_APPS_LINK_DRAG_ERROR,
  CLEAR_MOBILE_APPS_LINK_DRAG,
} from 'redux/links/types';

const initialState = {
  linksList: null,
  linksListError: null,
  linksDragSuccess: null,
  linksDragError: null,
  addLinkSuccess: null,
  addLinkError: null,
  deleteLinkSuccess: null,
  deleteLinkError: null,
  patchLinkSuccess: null,
  patchLinkError: null,
  socialNetworksList: null,
  socialNetworksListError: null,
  socialLinksList: null,
  socialLinksListError: null,
  addSocialLinkSuccess: null,
  addSocialLinkError: null,
  deleteSocialLinkSuccess: null,
  deleteSocialLinkError: null,
  patchSocialLinkSuccess: null,
  patchSocialLinkError: null,
  socialLinksButtonsModeSuccess: null,
  socialLinksButtonsModeError: null,
  createSocialLinkRequestStatusSuccess: null,
  createSocialLinkRequestStatusError: null,
  mobileAppsLinksList: null,
  mobileAppsLinksListError: null,
  addMobileAppsLinkSuccess: null,
  addMobileAppsLinkError: null,
  patchMobileAppsLinkSuccess: null,
  pacthMobileAppsLinkError: null,
  deleteMobileAppsLinkSuccess: null,
  deleteMobileAppsLinkError: null,
  mobileAppsLinksDragSuccess: null,
  mobileAppsLinksDragError: null,
};


export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LINKS_LIST:
      return {
        ...state,
        linksList: action.payload.data,
        linksListError: null,
      };
    case FETCH_LINKS_LIST_ERROR:
      return {
        ...state,
        linksList: null,
        linksListError: action.payload.data,
      };
    case CLEAR_FETCH_LINKS_LIST:
      return {
        ...state,
        linksDragSuccess: null,
        linksDragError: null,
      };
    case APPLY_LINK_DRAG:
      return {
        ...state,
        linksDragSuccess: true,
        linksDragError: null,
      };
    case APPLY_LINK_DRAG_ERROR:
      return {
        ...state,
        linksDragSuccess: null,
        linksDragError: action.payload.data,
      };
    case CLEAR_LINK_DRAG:
      return {
        ...state,
        linksDragSuccess: null,
        linksDragError: null,
      };
    case ADD_LINK_SUCCESS:
      return {
        ...state,
        addLinkSuccess: true,
        addLinkError: null,
      };
    case ADD_LINK_ERROR:
      return {
        ...state,
        addLinkSuccess: null,
        addLinkError: action.payload.data,
      };
    case CLEAR_ADD_LINK:
      return {
        ...state,
        addLinkSuccess: null,
        addLinkError: null,
      };
    case DELETE_LINK_SUCCESS:
      return {
        ...state,
        deleteLinkSuccess: true,
        deleteLinkError: null,
      };
    case DELETE_LINK_ERROR:
      return {
        ...state,
        deleteLinkSuccess: null,
        deleteLinkError: action.payload.data,
      };
    case CLEAR_DELETE_LINK:
      return {
        ...state,
        deleteLinkSuccess: null,
        deleteLinkError: null,
      };
    case PATCH_LINK_SUCCESS:
      return {
        ...state,
        patchLinkSuccess: action.payload.data,
        patchLinkError: null,
      };
    case PATCH_LINK_ERROR:
      return {
        ...state,
        patchLinkSuccess: null,
        patchLinkError: action.payload.data,
      };
    case CLEAR_PATCH_LINK:
      return {
        ...state,
        patchLinkSuccess: null,
        patchLinkError: null,
      };
    case FETCH_SOCIAL_NETWORKS_LIST:
      return {
        ...state,
        socialNetworksList: action.payload.data,
        socialNetworksListError: null,
      };
    case FETCH_SOCIAL_NETWORKS_LIST_ERROR:
      return {
        ...state,
        socialNetworksList: null,
        socialNetworksListError: action.payload.data,
      };
    case CLEAR_FETCH_SOCIAL_NETWORKS_LIST:
      return {
        ...state,
        socialNetworksList: null,
        socialNetworksListError: null,
      };
    case FETCH_SOCIAL_LINKS_LIST:
      return {
        ...state,
        socialLinksList: action.payload.data,
        socialLinksListError: null,
      };
    case FETCH_SOCIAL_LINKS_LIST_ERROR:
      return {
        ...state,
        socialLinksList: null,
        socialLinksListError: action.payload.data,
      };
    case CLEAR_FETCH_SOCIAL_LINKS_LIST:
      return {
        ...state,
        socialLinksList: null,
        socialLinksListError: null,
      };
    case ADD_SOCIAL_LINK_SUCCESS:
      return {
        ...state,
        addSocialLinkSuccess: action.payload.data,
        addSocialLinkError: null,
      };
    case ADD_SOCIAL_LINK_ERROR:
      return {
        ...state,
        addSocialLinkSuccess: null,
        addSocialLinkError: action.payload.data,
      };
    case CLEAR_ADD_SOCIAL_LINK:
      return {
        ...state,
        addSocialLinkSuccess: null,
        addSocialLinkError: null,
      };
    case DELETE_SOCIAL_LINK_SUCCESS:
      return {
        ...state,
        deleteSocialLinkSuccess: action.payload.data,
        deleteSocialLinkError: null,
      };
    case DELETE_SOCIAL_LINK_ERROR:
      return {
        ...state,
        deleteSocialLinkSuccess: null,
        deleteSocialLinkError: action.payload.data,
      };
    case CLEAR_DELETE_SOCIAL_LINK:
      return {
        ...state,
        deleteSocialLinkSuccess: null,
        deleteSocialLinkError: null,
      };
    case PATCH_SOCIAL_LINK_SUCCESS:
      return {
        ...state,
        patchSocialLinkSuccess: action.payload.data,
        patchSocialLinkError: null,
      };
    case PATCH_SOCIAL_LINK_ERROR:
      return {
        ...state,
        patchSocialLinkSuccess: null,
        patchSocialLinkError: action.payload.data,
      };
    case CLEAR_PATCH_SOCIAL_LINK:
      return {
        ...state,
        patchSocialLinkSuccess: null,
        patchSocialLinkError: null,
      };
    case SET_SOCIAL_LINKS_BUTTONS_MODE_SUCCESS:
      return {
        ...state,
        socialLinksButtonsModeSuccess: action.payload.data,
        socialLinksButtonsModeError: null,
      };
    case SET_SOCIAL_LINKS_BUTTONS_MODE_ERROR:
      return {
        ...state,
        socialLinksButtonsModeSuccess: null,
        socialLinksButtonsModeError: action.payload.data,
      };
    case CLEAR_SET_SOCIAL_LINKS_BUTTONS_MODE:
      return {
        ...state,
        socialLinksButtonsModeSuccess: null,
        socialLinksButtonsModeError: null,
      };
    case REQUEST_SOCIAL_LINK_STATUS_SUCCESS:
      return {
        ...state,
        createSocialLinkRequestStatusSuccess: action.payload.data,
        createSocialLinkRequestStatusError: null,
      };
    case REQUEST_SOCIAL_LINK_STATUS_ERROR:
      return {
        ...state,
        createSocialLinkRequestStatusSuccess: null,
        createSocialLinkRequestStatusError: action.payload.data,
      };
    case CLEAR_REQUEST_SOCIAL_LINK_STATUS:
      return {
        ...state,
        createSocialLinkRequestStatusSuccess: null,
        createSocialLinkRequestStatusError: null,
      }
    case FETCH_MOBILE_APPS_LINKS_LIST:
      return {
        ...state,
        mobileAppsLinksList: action.payload.data,
        mobileAppsLinksListError: null,
      };
    case FETCH_MOBILE_APPS_LINKS_LIST_ERROR:
      return {
        ...state,
        mobileAppsLinksList: null,
        mobileAppsLinksListError: action.payload.data,
      };
    case CLEAR_FETCH_MOBILE_APPS_LINKS_LIST:
      return {
        ...state,
        mobileAppsLinksList: null,
        mobileAppsLinksListError: null,
      };
    case ADD_MOBILE_APPS_LINK_SUCCESS:
      return {
        ...state,
        addMobileAppsLinkSuccess: action.payload.data,
        addMobileAppsLinkError: null,
      };
    case ADD_MOBILE_APPS_LINK_ERROR:
      return {
        ...state,
        addMobileAppsLinkSuccess: null,
        addMobileAppsLinkError: action.payload.data,
      };
    case CLEAR_ADD_MOBILE_APPS_LINK:
      return {
        ...state,
        addMobileAppsLinkSuccess: null,
        addMobileAppsLinkError: null,
      };
    case PATCH_MOBILE_APPS_LINK_SUCCESS:
      return {
        ...state,
        patchMobileAppsLinkSuccess: action.payload.data,
        pacthMobileAppsLinkError: null,
      };
    case PATCH_MOBILE_APPS_LINK_ERROR:
      return {
        ...state,
        patchMobileAppsLinkSuccess: null,
        pacthMobileAppsLinkError: action.payload.data,
      };
    case CLEAR_PATCH_MOBILE_APPS_LINK:
      return {
        ...state,
        patchMobileAppsLinkSuccess: null,
        pacthMobileAppsLinkError: null,
      };
    case DELETE_MOBILE_APPS_LINK_SUCCESS:
      return {
        ...state,
        deleteMobileAppsLinkSuccess: action.payload.data,
        deleteMobileAppsLinkError: null,
      };
    case DELETE_MOBILE_APPS_LINK_ERROR:
      return {
        ...state,
        deleteMobileAppsLinkSuccess: null,
        deleteMobileAppsLinkError: action.payload.data,
      };
    case CLEAR_DELETE_MOBILE_APPS_LINK:
      return {
        ...state,
        deleteMobileAppsLinkSuccess: null,
        deleteMobileAppsLinkError: null,
      };
    case APPLY_MOBILE_APPS_LINK_DRAG_SUCCESS:
      return {
        ...state,
        mobileAppsLinksDragSuccess: true,
        mobileAppsLinksDragError: null,
      };
    case APPLY_MOBILE_APPS_LINK_DRAG_ERROR:
      return {
        ...state,
        mobileAppsLinksDragSuccess: null,
        mobileAppsLinksDragError: action.payload.data,
      };
    case CLEAR_MOBILE_APPS_LINK_DRAG:
      return {
        ...state,
        mobileAppsLinksDragSuccess: null,
        mobileAppsLinksDragError: null,
      };
    default:
      return state;
  }
};
